import { Component, OnInit, Input } from '@angular/core';
import { Shared } from '../shared.service'
import { SlicePipe } from '@angular/common';

@Component({
  selector: 'print-half-page',
  templateUrl: './print-half-page.component.html',
  styleUrls: ['./print-half-page.component.scss']
})
export class PrintHalfPageComponent implements OnInit {

  @Input() page;
	@Input() max;
	@Input() layout;
  @Input() products;
	currentPage;
	a;
	b;

  constructor(private shared: Shared) { }

  ngOnInit() { 
  	this.findAB();
  	this.numberPages();
  }

  findAB(){
  	//console.log("Page: ", this.page);
  	this.a = (this.page * this.max);
  	//console.log('a:', this.a);
  	this.b = (this.a + this.max);
  	//console.log('b:', this.b);
  }

  numberPages(){
  	this.currentPage = (this.page + 1);
  	//console.log("Page: ", this.currentPage);
  }

}



// WEBPACK FOOTER //
// ./src/app/print-half-page/print-half-page.component.ts